<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 14:01:03
 * @LastEditTime: 2020-06-15 14:29:10
 * @Description: 搜索栏
 -->
 <template>
   <div class="search-bar">
     <span>姓名：</span>
     <input type="text" v-model="value" placeholder="请输入姓名或账号">
     <pss-button class="search-btn" text="搜索" @on-click="searchBtnClickHandler" />
   </div>
 </template>

<script>
export default {
  name: 'SearchBar',
  data() {
    return {
      value: '',
    };
  },
  methods: {
    /**
     * 点击搜索按钮处理函数
     */
    searchBtnClickHandler() {
      if (this.value) {
        this.$emit('on-search', this.value);
      } else {
        this.$emit('repull-list');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search-bar {
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;

  > input {
    padding: 2px 6px;
    font-size: 12px;

    &::placeholder {
      font-size: 12px;
    }
  }

  > .search-btn {
    margin-left: 8px;
  }
}
</style>
